/* ALLDAY nurse listicle: progress bar, scroll reveals, count-ups, sticky buy bar, shift guide. No dependencies. */
(function () {
  var d = document, w = window, root = d.documentElement;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in w;
  var $ = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };
  root.classList.add('nhl-js');

  function init() {
    // Reading progress
    var prog = d.querySelector('.nhl-prog'), ticking = false;
    if (prog) {
      var paint = function () {
        var max = root.scrollHeight - w.innerHeight;
        prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, w.scrollY / max) : 0) + ')';
        ticking = false;
      };
      w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(paint); } }, { passive: true });
      paint();
    }

    guide();

    var bar = d.querySelector('.nhl-bar');
    if (!hasIO) { if (bar) bar.classList.add('show'); return; }
    if (!reduce) root.classList.add('anim');

    // Reveals + count-ups
    var count = function (el) {
      var to = +el.getAttribute('data-to') || 0, t0 = null;
      if (reduce || to < 5) return;
      var step = function (t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 900);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
        if (k < 1) w.requestAnimationFrame(step);
      };
      el.textContent = '0';
      w.requestAnimationFrame(step);
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        $('[data-to]', e.target).forEach(count);
        io.unobserve(e.target);
      });
    }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    $('.nhl-rv').forEach(function (el) { io.observe(el); });

    // Sticky buy bar: after the hero CTA leaves the top, hidden while the buy box is on screen
    if (!bar) return;
    var cta = d.querySelector('[data-nhl-hero-cta]'), get = d.getElementById('get'), out = false, inBox = false;
    var box = get && get.closest('.shopify-section');
    box = box && box.nextElementSibling || get;
    var sync = function () {
      var on = out && !inBox;
      bar.classList.toggle('show', on);
      bar.inert = !on;
      d.body.classList.toggle('nhl-bar-on', on);
    };
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === cta) out = !e.isIntersecting && e.boundingClientRect.top < 0;
        else inBox = e.isIntersecting;
      });
      sync();
    });
    if (cta) io2.observe(cta);
    if (box) io2.observe(box);
    sync();
  }

  // "How to use it on shift"
  function guide() {
    var g = d.querySelector('.nhl-use');
    if (!g) return;
    var tabs = $('[role="tab"]', g), panels = $('[role="tabpanel"]', g), dots = $('.nhl-dot', g);
    var fill = g.querySelector('.nhl-track__fill'), pin = g.querySelector('.nhl-track__pinrail'), gap = g.querySelector('.nhl-track__gap');
    var hour = g.querySelector('[data-hour-out]'), cnt = g.querySelector('[data-count-out]'), lbl = g.querySelector('[data-label-out]'), nxt = g.querySelector('[data-next-label]');
    var cur = 0;
    var show = function (i, focus) {
      cur = (i + panels.length) % panels.length;
      var p = panels[cur].dataset, n = +p.fill, o = +p.opt;
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === cur); t.tabIndex = k === cur ? 0 : -1; });
      panels.forEach(function (el, k) { el.hidden = k !== cur; });
      dots.forEach(function (el, k) {
        el.classList.toggle('on', k < n);
        el.classList.toggle('opt', k >= n && k < n + o);
        el.style.transitionDelay = k * 30 + 'ms';
      });
      fill.style.transform = 'scaleX(' + p.bar / 100 + ')';
      pin.style.transform = 'translateX(' + p.pin + '%)';
      gap.style.opacity = p.gap === '1' ? 1 : 0;
      hour.textContent = p.hour;
      cnt.textContent = p.count;
      lbl.innerHTML = p.label;
      var nx = (cur + 1) % panels.length;
      nxt.textContent = nx ? nxt.getAttribute('data-next') + ' ' + tabs[nx].textContent : nxt.getAttribute('data-again');
      if (focus) tabs[cur].focus();
      var tl = tabs[cur].parentNode;
      tl.scrollTo({ left: tabs[cur].offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
    };
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) {
        var m = { ArrowRight: cur + 1, ArrowLeft: cur - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (m !== undefined) { e.preventDefault(); show(m, true); }
      });
    });
    var nb = g.querySelector('.nhl-next');
    if (nb) nb.addEventListener('click', function () { show(cur + 1); });
    var stage = g.querySelector('.nhl-stage'), x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    show(0);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
